import axios from 'axios'
import { $campaigns, $users, $paginated } from '@/services/'

export default {
    namespaced: true,
    state: {
        oldBrandId: null,
        dropdownLoader: false,
        currentStep: 1,
        finishedStep: 0,
        contacts: {
          lists: [],
          segments: [],
          suppressed_lists: [],
          send_test_lists: [],
          suppressed_segments: []
        },
        id: null,
        content_preview: false,
        privileges: {
            enableCTO: true,
            enableSecureList: true,
            enableSTO: true,
            enableTable: true,
            enableBrands : true
        },
        scheduleTypes: [
          { id: 1, name: 'Send Now' },
          { id: 2, name: 'Priority Send' },
          { id: 3, name: 'Time Zone Optimization' },
          { id: 4, name: 'Send-Time Optimization' },
          { id: 5, name: 'Conversion-Time Optimization' },
          { id: 6, name: 'Recurring' },
        ],
        scheduleWithItems: [],
        campaignSuccess: false,
        sendNow: false,
        type: 1,
        campaignName: '',
        savedCampaignName: '',
        scheduleData: {
            preset: false,
            sendAt: '',
            approvers: [],
            type: null,
            data: {
                campaign: {
                    recurring: {
                        schedule: '',
                    },
                },
                commit: '',
            },
        },
        contactFilters: {
            tags: {
                items: [],
                ids: [],
            },
            brands: [],
            lists: [],
            tables: [],
            journeys: [],
            secureLists: [],
            contents: []
        },
        packageFeatures: {}
    },
    mutations: {
          setCampaignId: (state, value) => {
            state.id = value
          },
          setContactFilter (state, payload) {
            state.contactFilters[payload.type] = payload.items
          },
          setCampaignTagsFilter (state, payload) {
            state.contactFilters[payload.type].items = payload.items
          },
          packageFeatures: (state, result) => {
            let value = result.data
            state.scheduleWithItems = [...state.scheduleTypes]
            if(result.data.brands) state.privileges.enableBrands = result.data.brands
            else state.privileges.enableBrands = false
            if (value.account_setting) {
                if (value.account_setting.package_feature) {
                    state.packageFeatures = value.account_setting.package_feature
                    state.privileges.enableSTO = state.packageFeatures.send_time_optimization ? state.packageFeatures.send_time_optimization === 'yes' : true
                    state.privileges.enableTable = state.packageFeatures.relational_data ? state.packageFeatures.relational_data === 'yes' : true
                    if (!state.privileges.enableSTO) {
                        const index = state.scheduleWithItems.findIndex(value => value.id === 4)
                        if (index > 0) state.scheduleWithItems.splice(index, 1)
                    }
                }
            }
            if (!value.products_and_revenue) state.privileges.enableCTO = false
            else {
              if (value.account_setting) {
                  const setting = value.account_setting
                  if (setting.package_feature && Object.keys(setting.package_feature).length !== 0) {
                    state.privileges.enableCTO = (setting.package_feature.products_and_revenue === 'yes' && setting.package_feature.conversion_time_optimization === 'yes')
                  } else state.privileges.enableCTO = true
              }
            }
            if (!state.privileges.enableCTO) {
                const index = state.scheduleWithItems.findIndex(value => value.id === 5)
                if (index > 0) state.scheduleWithItems.splice(index, 1)
            }
            if (!value.enable_secure_suppression_list) state.privileges.enableSecureList = false
            else {
              if (value.account_setting) {
                  const setting = value.account_setting
                  if (setting.package_feature && Object.keys(setting.package_feature).length !== 0) { state.privileges.enableSecureList = setting.package_feature.secure_suppression_lists === 'yes' } else state.privileges.enableSecureList = true
              }
              if (state.privileges.enableSecureList) {
                $campaigns.getSecureLists(result.payload).then(response => {
                    const data = response.data.data.secure_lists
                    state.contactFilters.secureLists = data
                })
              }
            }
            if (state.privileges.enableTable) {
                $campaigns.getTables().then(response => {
                    const data = response.data.data.relational_tables
                    state.contactFilters.tables = data
                })
              }
          },

    },
    actions: {
        getPackageFeatures ({ commit }, payload = null) {
            $users.getPackageFeatures().then(response => {
                commit('packageFeatures', {data : response.data.data, payload : payload})
            })
        },
        fetchTags({ commit }) {
          $campaigns.getTags().then(response => {
            let allcTcags = []
            if (response.data.data.ctags.length) {
              allcTcags = [{
                id: 'select-all',
                name: 'Select All',
                children: [],
                }]
              allcTcags[0].children = response.data.data.ctags
              commit('setCampaignTagsFilter', { type: 'tags', items: allcTcags })
            } else {
             commit('setCampaignTagsFilter', { type: 'tags', items: response.data.data.ctags })
            }
        })
        },
        fetchContactFilters ({ commit, state }, payload = null) {
            $campaigns.getBrands().then(response => {
                commit('setContactFilter', { type: 'brands', items: response.data.data.brands })
            })
            $campaigns.getWorkflows(payload).then(response => {
                commit('setContactFilter', { type: 'journeys', items: response.data.data.journeys })
            })
            $paginated.getList({
              params: {
                list_type: 'normal',
                page: 1,
                per_page: 10,
                no_folder: true,
              },
            }).then(response => {
                commit('setContactFilter', { type: 'lists', items: response.data.data.lists })
            })
          },
    },
    getters: {
      contactFilters: state => state.contactFilters
    },
}